import { styled, TableCell, tableCellClasses } from "@mui/material";
import React from "react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export default function MDTableCell({ children, ...rest }: any) {
  return <StyledTableCell {...rest}>{children}</StyledTableCell>;
}
